import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Providers
import { WindowMessageService, PostMessageService, UserDataService } from './';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    WindowMessageService,
    PostMessageService,
    UserDataService
  ],
  declarations: []
})
export class MessagingModule { }
